import * as Yup from 'yup';

import {addressValidation} from 'validation/fields/address';
import {cityValidation} from 'validation/fields/city';
import {emailValidation} from 'validation/fields/email';
import {phoneNumberValidation} from 'validation/fields/phonenumber';
import {zipCanadaValidation, zipUSValidation} from 'validation/fields/zip';

export const PersonalInfoModuleValidation = Yup.object().shape({
  address: addressValidation.required('Address is required'),
  address2: addressValidation,
  city: cityValidation.required('City is required'),
  email: emailValidation.required('Email Address is required'),
  zip: Yup.string().when('country', {
    is: country => country?.code === 'CAN' || country?.code === 'USA',
    then: Yup.string()
      .when('country', {
        is: country => country?.code === 'CAN',
        then: zipCanadaValidation,
        otherwise: zipUSValidation,
      })
      .required('Postal code required'),
    otherwise: Yup.string(),
  }),
  homePhone: phoneNumberValidation,
  cellPhone: phoneNumberValidation,
  state: Yup.object().when('country', {
    is: country => country?.code === 'USA',
    then: Yup.object().required('State is required'),
  }),
  province: Yup.object().when('country', {
    is: country => country?.code === 'CAN',
    then: Yup.object().required('Province is required'),
  }),
});
